/*
 * @Author: your name
 * @Date: 2021-08-05 19:01:47
 * @LastEditTime: 2021-08-08 15:49:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const templateRoute: RouteConfig[] = [
  {
    path: '/template',
    component: PView,
    redirect: '/template/list.html',
    children: [
      {
        path: 'list.html',
        name: 'template',
        component: () => import('@/views/template/index.vue'),
        meta: { title: '', parentTab: 'template' },
      },
      {
        path: 'detail.html',
        name: 'voteDetail',
        component: () => import('@/views/template/voteDetail.vue'),
        meta: { title: '模板案例详情', parentTab: 'template' },
      },
      {
        path: 'detailQuestion.html',
        name: 'questionDetail',
        component: () => import('@/views/template/questionDetail.vue'),
        meta: { title: '问卷模板详情', parentTab: 'template' },
      },
    ],
  },
];

export { templateRoute };
